import React from 'react';
import './ColorBlock.css';

const ColorBlock = ({ color, type, isSelected, onClick, ...props }) => {
  const blockClass = `color-block ${color} ${type} ${isSelected ? 'selected' : ''}`;
  
  return (
    <div className={blockClass} onClick={onClick} {...props}>
      {type === 'bomb' && <div className="bomb-icon">💣</div>}
      {type === 'rainbow' && <div className="rainbow-icon">🌈</div>}
    </div>
  );
};

export default ColorBlock;
